import React, { Fragment } from 'react'
import * as Logger from 'loglevel'
import * as HubConstant from '../util/HubConstant'
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap'
import AudioPlayer from 'react-h5-audio-player'
import 'react-h5-audio-player/lib/styles.css'
// import ReactAudioPlayer from 'react-audio-player';
import '../../styles/MediaContent.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faDownload,
  faEdit,
  faSearchPlus
} from '@fortawesome/free-solid-svg-icons'

import ClipLoader from 'react-spinners/ClipLoader'
import { css } from '@emotion/core'
import MediaPreviewer from './MediaPreviewer'

class MediaContent extends React.Component {
  constructor(props) {
    super(props)
    this.player = React.createRef()
    this.state = {
      // just for audio/video, Chrome has that weird issue where URL with parameters --> progress bar jumps back to 0 on drag:
      audioBlobURL: '',
      isAudioBlobCreated: false,
      isAudioPlaying: false,
      isMediaPreviewerActive: false,
      isDownloadingMedia: false
    }
  }

  // async componentDidMount() {
  //   if (
  //     this.props.contentType === HubConstant.MEDIA_CONTENT_AUDIO ||
  //     this.props.contentType === HubConstant.MEDIA_CONTENT_VIDEO
  //   ) {
  //     const blob = await fetch(this.props.mediaFetchUrl).then((r) => r.blob())
  //     this.setState({ audioBlobURL: URL.createObjectURL(blob) }, () =>
  //       this.setState({ isAudioBlobCreated: true })
  //     )
  //   } else {
  //     this.setState({ isAudioBlobCreated: true })
  //   }
  // }

  renderMediaDownloadButton(buttonName, loaderSize, loaderColor) {
    return (
      <div
        className={`${buttonName} ${
          this.state.isDownloadingMedia ? 'downloading' : ''
        }`}
        onClick={() => {
          if (this.props.onDownloadMedia && !this.state.isDownloadingMedia) {
            this.setState({ isDownloadingMedia: true }, async () => {
              await this.props.onDownloadMedia(
                this.props.elementId,
                this.props.elementName
              )
              this.setState({ isDownloadingMedia: false })
            })
          }
        }}
      >
        {this.state.isDownloadingMedia ? (
          <ClipLoader
            size={loaderSize}
            color={loaderColor}
            loading={this.state.isDownloadingMedia}
          />
        ) : (
          <FontAwesomeIcon icon={faDownload} />
        )}
      </div>
    )
  }

  render() {
    if (this.props.mediaFetchUrl) {
      let mediaContent = <Fragment />
      // Fix this to allow text too...
      switch (this.props.contentType) {
        case HubConstant.MEDIA_CONTENT_AUDIO: // audio
          mediaContent = (
            <Card
              className={`AudioPlayer ${
                this.state.isAudioPlaying ? 'playing' : ''
              }`}
            >
              <Card.Body>
                <OverlayTrigger
                  key={`mediaContent${this.props.elementId}`}
                  placement='top-start'
                  overlay={
                    <Tooltip
                      className='rowActionTooltip audioPlayerTooltip'
                      {...this.props}
                    >
                      {this.props.elementName}
                    </Tooltip>
                  }
                >
                  <div>
                    <div className='mediaTitle'>{this.props.elementName}</div>
                    <AudioPlayer
                      src={this.props.mediaFetchUrl}
                      ref={this.player}
                      volume={0.6}
                      autoPlay={false}
                      autoPlayAfterSrcChange={false}
                      onPlay={(e) => {
                        this.setState({ isAudioPlaying: true })
                        if (this.props.onPreviewMedia)
                          this.props.onPreviewMedia(this.props.elementId)
                      }}
                      onPause={(e) => {
                        this.setState({ isAudioPlaying: false })
                        if (this.props.onPreviewMedia)
                          this.props.onPreviewMedia(this.props.elementId)
                      }}
                      onAbort={(e) => {
                        this.setState({ isAudioPlaying: false })
                        if (this.props.onPreviewMedia)
                          this.props.onPreviewMedia(this.props.elementId)
                      }}
                      onEnded={(e) => {
                        this.setState({ isAudioPlaying: false })
                        if (this.props.onPreviewMedia)
                          this.props.onPreviewMedia(this.props.elementId)
                      }}
                    />
                    <OverlayTrigger
                      key={`mediaContentAudioPlayer${this.props.elementId}`}
                      placement='top-start'
                      overlay={
                        <Tooltip
                          className='rowActionTooltip audioPlayerTooltip'
                          {...this.props}
                        >
                          Download this audio
                        </Tooltip>
                      }
                    >
                      {this.renderMediaDownloadButton(
                        'audioDownloadButton',
                        15,
                        '#868686'
                      )}
                    </OverlayTrigger>
                    <div className='outQAudio'>
                      <span>
                        {this.props.outQ ? `Out-Queue: ${this.props.outQ}` : ''}
                      </span>
                      {this.props.onEditOutQ && this.props.outQ ? (
                        <OverlayTrigger
                          key={`mediaContentVideo_OutQueue${this.props.elementId}`}
                          placement='bottom-start'
                          overlay={
                            <Tooltip
                              className='rowActionTooltip audioPlayerTooltip'
                              {...this.props}
                            >
                              Update Out-Queue
                            </Tooltip>
                          }
                        >
                          <FontAwesomeIcon
                            className='audioPlayerButton editOutQButton'
                            icon={faEdit}
                            onClick={() =>
                              this.props.onEditOutQ({
                                elementId: this.props.elementId,
                                elementName: this.props.elementName,
                                outQ: this.props.outQ,
                                verbatim: this.props.verbatim
                              })
                            }
                          />
                        </OverlayTrigger>
                      ) : (
                        <Fragment />
                      )}
                    </div>
                  </div>
                </OverlayTrigger>
              </Card.Body>
            </Card>
          )
          break
        case HubConstant.MEDIA_CONTENT_VIDEO: // video
          mediaContent = (
            <div className='videoWrapper'>
              <OverlayTrigger
                key={`mediaContentVideo${this.props.elementId}`}
                placement='top-start'
                overlay={
                  <Tooltip
                    className='rowActionTooltip audioPlayerTooltip'
                    {...this.props}
                  >
                    Download this video
                  </Tooltip>
                }
              >
                {this.renderMediaDownloadButton(
                  'videoDownloadButton',
                  20,
                  '#474747'
                )}
              </OverlayTrigger>
              <video
                width='320'
                height='240'
                title={this.props.elementName}
                controlsList='nodownload'
                controls
                onPlay={() => {
                  if (this.props.onPreviewMedia)
                    this.props.onPreviewMedia(this.props.elementId)
                }}
              >
                {' '}
                <source
                  src={this.props.mediaFetchUrl}
                  type={this.props.mimeType}
                />{' '}
              </video>
              <div className='OutQVideo'>
                <span>
                  {this.props.outQ ? `Out-Queue: ${this.props.outQ}` : ''}
                </span>
                {this.props.onEditOutQ && this.props.outQ ? (
                  <OverlayTrigger
                    key={`mediaContentVideo_OutQueue${this.props.elementId}`}
                    placement='bottom-start'
                    overlay={
                      <Tooltip
                        className='rowActionTooltip audioPlayerTooltip'
                        {...this.props}
                      >
                        Update Out-Queue
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon
                      className='audioPlayerButton editOutQButton'
                      icon={faEdit}
                      onClick={() =>
                        this.props.onEditOutQ({
                          elementId: this.props.elementId,
                          elementName: this.props.elementName,
                          outQ: this.props.outQ,
                          verbatim: this.props.verbatim
                        })
                      }
                    />
                  </OverlayTrigger>
                ) : (
                  <Fragment />
                )}
              </div>
            </div>
          )
          break
        case HubConstant.MEDIA_CONTENT_IMAGE: // image
          mediaContent = (
            <div className='imgWrapper'>
              <MediaPreviewer
                isOpen={this.state.isMediaPreviewerActive}
                imgName={this.props.elementName}
                imgUrl={this.props.mediaFetchUrl}
                onClose={() => this.setState({ isMediaPreviewerActive: false })}
              />
              <OverlayTrigger
                key={`mediaContentImage${this.props.elementId}`}
                placement='top-start'
                overlay={
                  <Tooltip
                    className='rowActionTooltip audioPlayerTooltip'
                    {...this.props}
                  >
                    Download this image
                  </Tooltip>
                }
              >
                {this.renderMediaDownloadButton(
                  'imgDownloadButton',
                  20,
                  '#474747'
                )}
              </OverlayTrigger>
              <OverlayTrigger
                key={`mediaContentImage_preview_${this.props.elementId}`}
                placement='bottom-start'
                overlay={
                  <Tooltip
                    className='rowActionTooltip audioPlayerTooltip'
                    {...this.props}
                  >
                    Preview this image
                  </Tooltip>
                }
              >
                <div
                  className='imgPreviewButton'
                  onClick={() => {
                    this.setState({ isMediaPreviewerActive: true })
                  }}
                >
                  <FontAwesomeIcon icon={faSearchPlus} />
                </div>
              </OverlayTrigger>
              <img
                src={this.props.mediaFetchUrl}
                className='img-fluid CollapsibleImg'
                alt={this.props.elementName}
              />
            </div>
          )
          break
        default:
          break
      }
      return mediaContent
    } else {
      const collapsibleLoaderOverride = css`
        position: relative;
        box-sizing: content-box;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 10px;
        margin-bottom: 10px;
      `
      return (
        <ClipLoader
          size={40}
          color='black'
          loading={this.state.loading}
          css={collapsibleLoaderOverride}
        />
      )
    }
  }
}

export default MediaContent
